import * as React from 'react';
import {connect} from "react-redux";
import {ApplicationState} from "../../store";
import {TextField, Button, FormControl, InputLabel, Select, MenuItem} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save"
import {Tab} from '../Tab';
import {PopupDialog} from '../../core/components/PopupDialog';
import {ResponsiveBar} from '@nivo/bar'
import {
	actionReportsInvoicesPaymentsFetch,
	actionReportsSetFromDate,
	actionReportsSetToDate
} from "../../store/reports";
import {InvoicePaymentPeriod} from "../../models/reports/InvoicePaymentPeriod";
import {t} from "../../core/localization";
import {Utility} from "../../core/Utility";
import DateFnsUtils from '@date-io/date-fns';
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
} from '@material-ui/pickers';
import {actionSetTabState} from "../../store/tabs/actions";
import {hr} from 'date-fns/esm/locale'
import {Formater} from "../../core/Formater";

export interface ReportPaymentsInvoicesProps {
	tab: Tab
	data: InvoicePaymentPeriod[],
	from: Date,
	to: Date
}

export interface ReportPaymentsInvoicesState {
	isDialogOpen: boolean,
	dialogTitle: string,
	dialogText: string
}

function mapStateToProps(state: ApplicationState) {
	return {
		state: state.tabs.active.state,
		item: state.tabs.active.item,
		tab: state.tabs.active,
		data: state.reports.list,
		from: state.reports.from,
		to: state.reports.to
	};
}

class ReportPaymentsInvoicesTab extends React.Component<ReportPaymentsInvoicesProps, ReportPaymentsInvoicesState> {

	constructor(props: ReportPaymentsInvoicesProps) {
		super(props)
		this.state = {isDialogOpen: false, dialogText: '', dialogTitle: ''}
    }

	componentDidMount() {
		actionReportsInvoicesPaymentsFetch()
	}

	onDialogClose () {
		this.setState({ ...this.state, isDialogOpen: false})
	}

	render(): React.ReactNode {
		return (
			<div style={{padding: '20px'}}>
				{this.renderFilter()}
				{this.renderForm()}
				{/*{this.renderControls()}*/}
				{this.renderPopupDialog()}
			</div>
		);
	}

	renderForm(): React.ReactNode {

		let data = []

		for (let item of this.props.data) {
			let newItem = {
				date: item.period,
				invoices: item.invoicesValue,
				payments: item.paymentsValue
			}
			data.push(newItem)
		}

		return <div style={{ height: 400 }}><ResponsiveBar
			data={data}
			keys={[ 'payments', 'invoices']}
			indexBy="date"
			margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
			padding={0.3}
			groupMode="grouped"
			labelFormat={v => Formater.formatPrice(parseFloat(v.toString()),2)}
			colors={{ scheme: 'nivo' }}
			defs={[
				{
					id: 'dots',
					type: 'patternDots',
					background: 'inherit',
					color: '#38bcb2',
					size: 4,
					padding: 1,
					stagger: true
				},
				{
					id: 'lines',
					type: 'patternLines',
					background: 'inherit',
					color: '#eed312',
					rotation: -45,
					lineWidth: 6,
					spacing: 10
				}
			]}
			fill={[
				{
					match: {
						id: 'fries'
					},
					id: 'dots'
				},
				{
					match: {
						id: 'sandwich'
					},
					id: 'lines'
				}
			]}
			// borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
			axisTop={null}
			axisRight={null}
			axisBottom={{
				tickSize: 5,
				tickPadding: 5,
				tickRotation: 0,
				legend: 'Mesec',
				legendPosition: 'middle',
				legendOffset: 32
			}}
			axisLeft={{
				tickSize: 5,
				tickPadding: 5,
				tickRotation: 0,
				legend: 'Iznos',
				legendPosition: 'middle',
				legendOffset: -40
			}}
			labelSkipWidth={12}
			labelSkipHeight={12}
			labelTextColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
			legends={[
				{
					dataFrom: 'keys',
					anchor: 'bottom-right',
					direction: 'column',
					justify: false,
					translateX: 120,
					translateY: 0,
					itemsSpacing: 2,
					itemWidth: 100,
					itemHeight: 20,
					itemDirection: 'left-to-right',
					itemOpacity: 0.85,
					symbolSize: 20,
					effects: [
						{
							on: 'hover',
							style: {
								itemOpacity: 1
							}
						}
					]
				}
			]}
			animate={true}
			motionStiffness={90}
			motionDamping={15}
		/></div>
	}

	renderFilter(): React.ReactNode {
		return <MuiPickersUtilsProvider utils={DateFnsUtils} locale={hr}>
			<KeyboardDatePicker
				margin="normal"
				id="date-picker-dialog"
				label={"Od"}
				format={Utility.PICKER_DATE_FORMAT}
				value={this.props.from}
				onChange={(e) => {actionReportsSetFromDate(e)}}
				onBlur={null}
				onFocus={null}
				KeyboardButtonProps={{
					'aria-label': 'change paymentDate',
				}}
				style={{marginRight: '10px'}}
			/>
			<KeyboardDatePicker
				margin="normal"
				id="date-picker-dialog"
				label={"Do"}
				format={Utility.PICKER_DATE_FORMAT}
				value={this.props.to}
				onChange={(e) => {actionReportsSetToDate(e)}}
				onBlur={null}
				onFocus={null}
				KeyboardButtonProps={{
					'aria-label': 'change paymentDate',
				}}
				style={{marginRight: '10px'}}
			/>
		</MuiPickersUtilsProvider>
	}

	renderControls(): React.ReactNode {
		return <div style={{display: 'flex', flexDirection:'row-reverse', marginTop: '10px'}}>
				<Button onClick={() => {}} variant="contained" color="primary" style={{}}><SaveIcon />Download</Button>
			</div>
	}

	renderPopupDialog(): React.ReactNode {
		return <PopupDialog
			isOpen={this.state.isDialogOpen}
			title={this.state.dialogTitle}
			text={this.state.dialogText}
			onClose={this.onDialogClose.bind(this)}
		/>
	}

	getFromTabState(key: string) {
		if (this.props.tab.state && this.props.tab.state[key]) return this.props.tab.state[key]
		return null
	}

	handleItemDateChange (date: Date | null, name: string) {
		let tabState = this.props.tab.state
		tabState[name] = date
		actionSetTabState(tabState)
	}
}

export default connect(mapStateToProps)(ReportPaymentsInvoicesTab);
